import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { currentProjectAtom, currentProjectIdAtom, updateProjectIdAtom } from '@/store/project-context';
import { ProjectKey, PROJECTS } from '@/config/projects';
import { ProjectFactory } from '@/utils/project-factory';

export const useProject = () => {
  const [currentProject] = useAtom(currentProjectAtom);
  const [currentProjectId] = useAtom(currentProjectIdAtom);
  const updateProject = useSetAtom(updateProjectIdAtom);

  // Obtener configuración del proyecto actual
  const projectConfig = PROJECTS[currentProject];
  
  // Log del proyecto actual para debugging
  useEffect(() => {
    console.log(`🔍 useProject - Proyecto actual: ${currentProject}, projectId: ${currentProjectId}`);
  }, [currentProject, currentProjectId]);
  
  // Crear cliente del proyecto
  const projectClient = ProjectFactory.createProjectClient(supabase, currentProject);

  // Obtener proyectos disponibles simplificado
  const availableProjects = Object.entries(PROJECTS).map(([key, config]) => ({
    key: key as ProjectKey,
    ...config,
    hasData: true // Simplificado para evitar recursión
  }));

  const setCurrentProject = (project: ProjectKey) => {
    if (ProjectFactory.validateProject(project)) {
      updateProject(project);
    } else {
      console.error(`Proyecto ${project} no está disponible`);
    }
  };

  return {
    currentProject,
    setCurrentProject,
    projectClient,
    projectConfig,
    projectId: currentProjectId,
    isLoading: false,
    error: null,
    availableProjects
  };
};